module.exports = __webpack_public_path__ + "static/media/Group 7008.dea3ec10.svg";